import type { SelectOption, SelectValue } from '@shared/ui/select';
import { SendInvitationChannel } from '../api/useSendInvitationMessages';
import { TicketDeliveryMethod } from '@features/modal-invitation/api/updateSetting';
import {
  INVITATION_TYPE_BOTH,
  INVITATION_TYPE_EMAIL,
  INVITATION_TYPE_SMS,
  INVITATION_TYPE_VK_TEAMS,
  type InvitationTypeValue,
} from './invitation-types';

export const INVITATION_CHANNEL_SELECT_OPTIONS: SelectOption[] = [
  { name: 'VK Teams', value: INVITATION_TYPE_VK_TEAMS },
  { name: 'E-mail', value: INVITATION_TYPE_EMAIL },
  { name: 'СМС', value: INVITATION_TYPE_SMS },
];

export const TICKET_CHANNEL_SELECT_OPTIONS: SelectOption[] = [
  { name: 'VK Teams', value: INVITATION_TYPE_VK_TEAMS },
  { name: 'E-mail', value: INVITATION_TYPE_EMAIL },
  { name: 'СМС', value: INVITATION_TYPE_SMS },
];

export const mapChannelsToLegacyType = (channels: SelectValue[]): InvitationTypeValue | null => {
  const hasSms = channels.includes(INVITATION_TYPE_SMS);
  const hasEmail = channels.includes(INVITATION_TYPE_EMAIL);

  if (!hasSms && !hasEmail) return null;
  if (hasSms && hasEmail) return INVITATION_TYPE_BOTH;
  if (hasSms) return INVITATION_TYPE_SMS;
  return INVITATION_TYPE_EMAIL;
};

export const mapSelectedChannelsToSendChannels = (channels: SelectValue[]): SendInvitationChannel[] => {
  const sendChannels: SendInvitationChannel[] = [];

  if (channels.includes(INVITATION_TYPE_VK_TEAMS)) {
    sendChannels.push(SendInvitationChannel.VK);
  }
  if (channels.includes(INVITATION_TYPE_EMAIL)) {
    sendChannels.push(SendInvitationChannel.Email);
  }
  if (channels.includes(INVITATION_TYPE_SMS)) {
    sendChannels.push(SendInvitationChannel.SMS);
  }

  return sendChannels;
};

export const mapSelectedTicketChannelsToDeliveryMethods = (channels: SelectValue[]): TicketDeliveryMethod[] => {
  const methods: TicketDeliveryMethod[] = [];

  if (channels.includes(INVITATION_TYPE_VK_TEAMS)) {
    methods.push(TicketDeliveryMethod.VK);
  }
  if (channels.includes(INVITATION_TYPE_EMAIL)) {
    methods.push(TicketDeliveryMethod.Email);
  }
  if (channels.includes(INVITATION_TYPE_SMS)) {
    methods.push(TicketDeliveryMethod.SMS);
  }

  return methods;
};

export const mapDeliveryMethodsToSelectedChannels = (methods: TicketDeliveryMethod[] | null): SelectValue[] => {
  if (!methods) return [];

  const channels: SelectValue[] = [];

  if (methods.includes(TicketDeliveryMethod.VK)) {
    channels.push(INVITATION_TYPE_VK_TEAMS);
  }
  if (methods.includes(TicketDeliveryMethod.Email)) {
    channels.push(INVITATION_TYPE_EMAIL);
  }
  if (methods.includes(TicketDeliveryMethod.SMS)) {
    channels.push(INVITATION_TYPE_SMS);
  }
  // Обратная совместимость: BOTH → SMS + Email
  if (methods.includes(TicketDeliveryMethod.Both)) {
    if (!channels.includes(INVITATION_TYPE_SMS)) channels.push(INVITATION_TYPE_SMS);
    if (!channels.includes(INVITATION_TYPE_EMAIL)) channels.push(INVITATION_TYPE_EMAIL);
  }

  return channels;
};
